var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 311.94 302.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#032635;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-786.41,621a76.63,76.63,0,0,1-76.54-76.55,76.62,76.62,0,0,1,76.54-76.54,76.63,76.63,0,0,1,76.55,76.54A76.64,76.64,0,0,1-786.41,621Zm0-139.73a63.26,63.26,0,0,0-63.19,63.18,63.26,63.26,0,0,0,63.19,63.19,63.25,63.25,0,0,0,63.19-63.19A63.25,63.25,0,0,0-786.41,481.28Z",
    transform: "translate(942.92 -387.95)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-846,477.76a5.35,5.35,0,0,1-.49,7.51h0a5.32,5.32,0,0,1-7.51-.5l-39.58-45.21a5.31,5.31,0,0,1,.5-7.49h0a5.3,5.3,0,0,1,7.51.49Z",
    transform: "translate(942.92 -387.95)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-780.88,453.31a5.31,5.31,0,0,1-5.27,5.35h0a5.31,5.31,0,0,1-5.36-5.28l-.43-60.07a5.31,5.31,0,0,1,5.27-5.36h0a5.31,5.31,0,0,1,5.36,5.29Z",
    transform: "translate(942.92 -387.95)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-877.29,529.86a5.33,5.33,0,0,1,4.87,5.73h0a5.32,5.32,0,0,1-5.74,4.87L-938,535.59a5.31,5.31,0,0,1-4.86-5.73h0a5.35,5.35,0,0,1,5.74-4.9Z",
    transform: "translate(942.92 -387.95)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-867.64,586.77a5.32,5.32,0,0,1,7.34,1.65h0a5.33,5.33,0,0,1-1.66,7.34l-50.79,32.1a5.29,5.29,0,0,1-7.33-1.64h0a5.31,5.31,0,0,1,1.66-7.34Z",
    transform: "translate(942.92 -387.95)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-822.27,626.36a5.31,5.31,0,0,1,6.85-3.1h0a5.35,5.35,0,0,1,3.12,6.86l-21.18,56.22a5.3,5.3,0,0,1-6.83,3.1h0a5.31,5.31,0,0,1-3.13-6.85Z",
    transform: "translate(942.92 -387.95)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-707.53,598a5.3,5.3,0,0,1-2.23-7.17h0a5.3,5.3,0,0,1,7.18-2.23l53.17,28a5.29,5.29,0,0,1,2.23,7.17h0a5.33,5.33,0,0,1-7.2,2.25Z",
    transform: "translate(942.92 -387.95)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-695.35,533.19a5.3,5.3,0,0,1-5.9-4.64h0a5.32,5.32,0,0,1,4.66-5.92l59.67-7a5.3,5.3,0,0,1,5.9,4.65h0a5.32,5.32,0,0,1-4.67,5.92Z",
    transform: "translate(942.92 -387.95)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-734.51,682.91a5.32,5.32,0,0,1-3.24,6.8h0a5.32,5.32,0,0,1-6.77-3.25l-20-56.68a5.3,5.3,0,0,1,3.24-6.77h0a5.3,5.3,0,0,1,6.79,3.24Z",
    transform: "translate(942.92 -387.95)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-724.68,479.24a5.33,5.33,0,0,1-7.47.94h0a5.32,5.32,0,0,1-.92-7.46l37-47.37a5.31,5.31,0,0,1,7.46-.92h0a5.34,5.34,0,0,1,.91,7.48Z",
    transform: "translate(942.92 -387.95)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.77f27c3930fec7354a899a7859676849.svg";
export { ForwardRef as ReactComponent };